import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient, getUseManualHoursReportsKey } from '@/hooks'
import {
  ManualHoursReport,
  APIErrorResponse,
  PostManualHoursReportApprove,
} from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'

export const usePostManualHoursReportDecline = ({
  id,
}: Pick<ManualHoursReport, 'id'>): UseMutationResult<
  ManualHoursReport,
  APIErrorResponse,
  PostManualHoursReportApprove
> => {
  const client = useApiClient()
  const queryClient = useQueryClient()
  const hrListKey = getUseManualHoursReportsKey(true)

  return useMutation(
    (params) =>
      client
        .post(`/hours_reporting/hr/manual-hours/${id}/decline/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(hrListKey)
      },
    }
  )
}
